// Selected community ID, app-wide. Read by every page that hangs off a
// single community context (Overview, Members, Lifecycle, Content, Alerts).
//
// In-memory only — there's no persist middleware. Mini App WebViews are
// ephemeral (PRD §8.0.4) and the natural boot sequence is "fetch the user's
// community list, default to the first one" — re-deriving on every open is
// cheaper than cache-coherency bugs around stale community ids that point
// at communities the user has since disconnected.

import { create } from "zustand";

export interface ActiveCommunityState {
  activeCommunityId: string | null;
}

export interface ActiveCommunityActions {
  setActiveCommunityId: (id: string | null) => void;
  reset: () => void;
}

export type ActiveCommunityStore = ActiveCommunityState &
  ActiveCommunityActions;

export const INITIAL_ACTIVE_COMMUNITY_STATE: ActiveCommunityState = {
  activeCommunityId: null,
};

export const useActiveCommunityStore = create<ActiveCommunityStore>((set) => ({
  ...INITIAL_ACTIVE_COMMUNITY_STATE,
  setActiveCommunityId: (id) => set({ activeCommunityId: id }),
  reset: () => set(INITIAL_ACTIVE_COMMUNITY_STATE),
}));

export const selectActiveCommunityId = (
  s: ActiveCommunityStore,
): string | null => s.activeCommunityId;
